import { render, staticRenderFns } from "./Generator.vue?vue&type=template&id=2fc5b05f&scoped=true"
import script from "./Generator.vue?vue&type=script&lang=js"
export * from "./Generator.vue?vue&type=script&lang=js"
import style0 from "./Generator.vue?vue&type=style&index=0&id=2fc5b05f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc5b05f",
  null
  
)

export default component.exports